import Vue from 'vue';
import App from './components/App.vue';
import GlobalMixin from './mixins/globalMixin.js';

window.LocatorConfig = window.LocatorConfig || {};

window.LocatorConfig.REYNOLDS = {
    ID                      : 'reynolds1',
    name                    : 'KINGDOM AT REYNOLDS LAKE OCONEE',
    address1                : '1 Lake Oconee Trail',
    address2                : '',
    postalCode              : '30642',
    city                    : 'Greensboro',
    stateCode               : 'GA',
    countryCode             : 'US',
    phone                   : '706-467-3563',
    storeHours              : '',
    storeWebsite            : '',
    storeEvents             : '',
    isFittingCenterLocation : '',
    isPerformanceLabLocation: '',
    isStudioLocation        : '',
    isSelectFitLocation     : '',
    isFittingLocation       : 'isFittingLocation',
    isOtherLocation         : '',
    isCertifiedLocation     : '',
    isPremierLocation       : 'isPremierLocation',
    isDemoDaysLocation      : '',
    latitude                : 33.4388113,
    longitude               : -83.1953351,
    isNFC                   : true,
    isAmbassadorLocation    : false
};

Vue.config.productionTip = false;

Vue.mixin(GlobalMixin);

new Vue({
    render: (h) => h(App)
}).$mount('#locator-app');
